module.exports = __webpack_public_path__ + "img/user-shield.93ee9b78.svg";